(function () {
  'use strict';

  var rootSelector = '.section-folivis-footer .folivis-footer';
  var mobileQuery = '(max-width: 767px)';

  function initialise(root) {
    if (!root || root.getAttribute('data-folivis-footer-ready') === 'true') {
      return;
    }

    var details = Array.prototype.slice.call(root.querySelectorAll('.folivis-footer__column'));
    var mediaQuery = window.matchMedia(mobileQuery);
    var isMobile = false;

    if (!details.length) {
      return;
    }

    root.setAttribute('data-folivis-footer-ready', 'true');

    function applyMode() {
      isMobile = mediaQuery.matches;

      details.forEach(function (detail) {
        var summary = detail.querySelector('summary');

        detail.open = !isMobile;

        if (!summary) {
          return;
        }

        summary.tabIndex = isMobile ? 0 : -1;

        if (isMobile) {
          summary.removeAttribute('aria-disabled');
        } else {
          summary.setAttribute('aria-disabled', 'true');
        }
      });
    }

    details.forEach(function (detail) {
      var summary = detail.querySelector('summary');

      if (!summary) {
        return;
      }

      summary.addEventListener('click', function (event) {
        if (!isMobile) {
          event.preventDefault();
        }
      });

      summary.addEventListener('keydown', function (event) {
        if (!isMobile && (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')) {
          event.preventDefault();
        }
      });

      detail.addEventListener('toggle', function () {
        if (!isMobile || !detail.open) {
          return;
        }

        details.forEach(function (other) {
          if (other !== detail) {
            other.open = false;
          }
        });
      });
    });

    applyMode();

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', applyMode);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(applyMode);
    }
  }

  function initialiseWithin(scope) {
    if (!scope || !scope.querySelectorAll) {
      return;
    }

    if (scope.matches && scope.matches(rootSelector)) {
      initialise(scope);
    }

    Array.prototype.forEach.call(scope.querySelectorAll(rootSelector), initialise);
  }

  initialiseWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialiseWithin(event.target);
  });
}());
